var map = {
	"./tapcoin/lucky/key.png": 64765,
	"./tapcoin/lucky/light1.png": 94421,
	"./tapcoin/lucky/light2.png": 73133,
	"./tapcoin/lucky/lucky-btn-bg.png": 2548,
	"./tapcoin/lucky/lucky-item-bg.png": 48012,
	"./tapcoin/lucky/lucky-result-coin-tap.png": 55788,
	"./tapcoin/lucky/lucky-result-coin-tapcoins.png": 16414,
	"./tapcoin/lucky/lucky-result-coin-tapstock.png": 43375,
	"./tapcoin/lucky/lucky-result-coin-ton.png": 82649,
	"./tapcoin/lucky/lucky-result-coin-usdt.png": 11104,
	"./tapcoin/lucky/lucky-result-light.png": 60268,
	"./tapcoin/lucky/tap.png": 35092,
	"./tapcoin/lucky/tapcoins.png": 78565,
	"./tapcoin/lucky/ton.png": 52808,
	"./tapcoin/lucky/usdt.png": 5976
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48147;